import { PlaceholderInspector } from "./PlaceholderInspector"
import type { ControlInspector } from "./types"

export const multilineText: ControlInspector<"multilineText"> = {
  Inspector: ({ field, onEdit }) => (
    <PlaceholderInspector placeholder={field.placeholder} onEdit={onEdit} />
  ),
}
